// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"0c12d4fe","190":"ceb533bd","313":"610fcc05","675":"6d389f07"}[chunkId] + ".chunk.css";
};